export default {
  rut: /^(\d{1,3}(?:\.?\d{3})*)-?(\d)$/,
};
